import { indexItems } from '@/mocks/homeData';

export default function SectionIndex() {
  return (
    <section id="index" className="w-full py-14 md:py-20 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground-950 mb-3">
            专题合集
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            精心策划的剧集专题，按类型与主题整理，帮你快速找到想看的剧
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 md:gap-5">
          {indexItems.map((item) => (
            <article
              key={item.id}
              className="group relative bg-background-50 border border-background-200/70 rounded-xl overflow-hidden hover:border-accent-300 transition-all duration-300 flex flex-col"
            >
              <div className="relative aspect-[3/2] overflow-hidden bg-background-100">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent"></div>
                <div className="absolute bottom-2.5 right-2.5">
                  <span className="px-2.5 py-1 rounded-full bg-background-50/90 text-foreground-800 text-xs font-medium whitespace-nowrap">
                    {item.count}
                  </span>
                </div>
              </div>
              <div className="p-4 md:p-5 flex flex-col flex-1">
                <h3 className="text-sm md:text-base font-heading font-semibold text-foreground-950 mb-1 group-hover:text-accent-600 transition-colors">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-500 mb-2">
                  {item.subtitle}
                </p>
                <p className="text-xs text-foreground-600 leading-relaxed flex-1 line-clamp-2">
                  {item.description}
                </p>
                <span className="inline-flex items-center gap-1 mt-3 text-xs font-medium text-accent-600 cursor-pointer whitespace-nowrap">
                  浏览专题 <i className="ri-arrow-right-line"></i>
                </span>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}